module.exports = __webpack_public_path__ + "static/media/amela-wiki-mobile.a0d9c796.svg";